import React, { useState } from 'react'
import TableIntervalPredikat from 'component/rapor/table-interval-predikat'
import NotFound from 'component/not-found'

export default function RaporError({ errorMessage }) {
  /* ======================================= Local States ======================================= */
  const [reloadStart, setReloadStart] = useState(false)

  /* ========================================= Functions ======================================== */
  const reloadPage = () => {
    setReloadStart(true)
    window.location.reload()
  }
  
  /* ========================================== Output ========================================== */
  return (
    <>
      <div className="row">
        <div className="col">
          <h2 className="f-24">-</h2>
          <div className="text-secondary">
            <span>
              <i className="fas fa-graduation-cap mr-1" />
              Semester/Tahun Ajaran
            </span>
            <span className="ml-3">
              <i className="fas fa-user-graduate mr-1" />
              {'0'}
              {' siswa'}
            </span>
            <span className="ml-3">
              <i className="fas fa-user-friends mr-1" />
              Kelas: -
            </span>
          </div>
          <hr />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          <h5>A. Tabel Interval Predikat</h5>
          <TableIntervalPredikat />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          <h5>B. Pengetahuan</h5>
          <div className="w-100">
            <button
              className="btn btn-sm btn-primary mr-2"
              disabled={true}
            >
              <i className="fas fa-check-circle mr-1" />
              Setuju
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              disabled={true}
            >
              <i className="fas fa-times-circle mr-1" />
              Tolak
            </button>
          </div>
          <div className="table-responsive rounded mt-2">
            <table className="table nowrap">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      className="form-control"
                      style={{ width: 16, height: 16 }}
                      disabled={true}
                    />
                  </th>
                  <th>No.</th>
                  <th>Nama</th>
                  <th>Nilai</th>
                  <th>Predikat</th>
                  <th>Deskripsi</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    colSpan={7}
                    className="text-center"
                  >
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <NotFound text={errorMessage} />
                      <button
                        className="btn btn-sm btn-primary mt-3"
                        onClick={reloadStart ? () => {} : reloadPage}
                        disabled={reloadStart}
                      >
                        {reloadStart ? (
                          <span
                            className="spinner-border spinner-border-sm mr-1"
                            role="status"
                          />
                        ) : (
                          <i className="fas fa-redo-alt mr-1" />
                        )}
                        Muat Ulang
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          <h5>C. Keterampilan</h5>
          <div className="w-100">
            <button
              className="btn btn-sm btn-primary mr-2"
              disabled={true}
            >
              <i className="fas fa-check-circle mr-1" />
              Setuju
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              disabled={true}
            >
              <i className="fas fa-times-circle mr-1" />
              Tolak
            </button>
          </div>
          <div className="table-responsive rounded mt-2">
            <table className="table nowrap">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      className="form-control"
                      style={{ width: 16, height: 16 }}
                      disabled={true}
                    />
                  </th>
                  <th>No.</th>
                  <th>Nama</th>
                  <th>Nilai</th>
                  <th>Predikat</th>
                  <th>Deskripsi</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    colSpan={7}
                    className="text-center"
                  >
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <NotFound text={errorMessage} />
                      <button
                        className="btn btn-sm btn-primary mt-3"
                        onClick={reloadStart ? () => {} : reloadPage}
                        disabled={reloadStart}
                      >
                        {reloadStart ? (
                          <span
                            className="spinner-border spinner-border-sm mr-1"
                            role="status"
                          />
                        ) : (
                          <i className="fas fa-redo-alt mr-1" />
                        )}
                        Muat Ulang
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}
